<template>
  <div>
    <DHeader/>
    <b-row class="ml-3">
      <b-col>
        <p class="action_link" @click="backToSetting()">
          <b-icon aria-hidden="true" icon="arrow-left-circle"></b-icon>
          ย้อนกลับ
        </p>
      </b-col>
    </b-row>
    <b-row class="text-center">
      <b-col>
        <p class="header-text"> รายการแพทย์ชันสูตรร่วมเพื่อใช้ในการเลือกกรอกแบบฟอร์ม</p>
      </b-col>
    </b-row>
    <div class="mt-5">
      <div class="setting_list_police">
        <div class="row col-12 my-3">
          <div class="col-2 offset-5">
            <b-button class="btn-outline-success btn-save btn-block" v-b-modal.modal-prevent-closing>
             <b-icon icon="plus-circle-fill"></b-icon> เพิ่ม
            </b-button>
          </div>
        </div>
        <template v-if="this.items_list_doctor.length>0">
<!--          <div class="row col-12 my-3">-->
<!--            <div class="col-2 offset-5">-->
<!--              <b-button class="btn-outline-success btn-save btn-block" v-b-modal.modal-prevent-closing>-->
<!--                เพิ่ม-->
<!--              </b-button>-->
<!--            </div>-->
<!--          </div>-->

          <b-table :fields="fields_List_doctor" :items="items_list_doctor" class="mx-auto text-center table-responsive " hover
                   striped style="display: inline-table">
            <template v-slot:cell()="{ value, item, field: { key }}">
              <template v-if="!item.isEditing">{{ value }}</template>
              <b-form-input v-else v-model="item[key]"/>
            </template>
            <template v-slot:cell(actions)="{ item }">
              <span v-if="!item.isEditing">
                   <b-button class="btn btn-outline-warning btn-edit mx-2" @click="onEdit(item)">
                              <b-icon icon="pencil-square"></b-icon>
                                แก้ไข
                   </b-button>
                 <b-button class="btn btn-outline-danger btn-delete mx-2"
                           @click="deleteDoctor(item.id,item.police_station)">
                <b-icon icon="trash"></b-icon>
                ลบ
              </b-button>
              </span>
              <span v-else>
                   <b-button class="btn btn-outline-success btn-save mx-2" @click="editDoctor(item)">
                              <b-icon icon="check-circle-fill"></b-icon> บันทึก
                   </b-button>
                 <b-button class="btn btn-outline-danger btn-delete mx-2"
                           @click="item.isEditing=!item.isEditing">
                <b-icon icon="x-circle-fill"></b-icon>
                ยกเลิก
              </b-button>
              </span>

            </template>
            <template #cell(no)="row">
              {{ row.index + 1 }}
            </template>
          </b-table>
        </template>
        <template v-else>
          <b-row class="text-center">
            <b-col>
              <p class="header-text"> ไม่พบข้อมูลแพทย์ชันสูตรร่วม</p>
            </b-col>
          </b-row>
        </template>
      </div>
      <b-modal
          id="modal-prevent-closing"
          ref="modal"
          title="เพิ่มแพทย์ชันสูตรร่วม"
          @hidden="resetModal"
          @ok="handleOk"
          @show="resetModal"
      >
        <form ref="form" @submit.stop.prevent="handleSubmit">
          <b-form-group
              :state="nameState"
              invalid-feedback="โปรดกรอกชื่อแพทย์"
              label="ชื่อ-นามสกุล"
              label-for="name-input"
          >
            <b-form-input
                id="name-input"
                v-model="name"
                :state="nameState"
                placeholder="ชื่อ-นามสกุล"
                required
            ></b-form-input>
          </b-form-group>
        </form>
      </b-modal>
    </div>
    <DFooter/>
  </div>

</template>

<script>
import {mapState} from 'vuex'
import DHeader from "@/components/Header";
import DFooter from "@/components/Footer";
import Swal from "sweetalert2";

export default {
  name: "settingDoctor",
  components: {
    DHeader,
    DFooter,
  },
  data() {
    return {
      province_select: "",
      filter: '',
      items_all: [],
      fields_all: [],
      items_list_doctor: [],
      fields_List_doctor: [
        {key: 'actions', label: 'จัดการ', tdClass: 'w-auto'},
        {key: 'id', label: '', thClass: 'd-none', tdClass: 'd-none'},
        {key: "no", label: "ลำดับ", tdClass: 'auto'},
        {key: "name", label: "ชื่อ", sortable: true, tdClass: 'w-50'},
      ],
      list_all_police_station: [],
      hospcode: null,
      name: '',
      nameState: null,
      Toast: null,
      name_editing: '',
      id_editing: '',
      is_editing: null,
      swalWithBootstrapButtons: null,
    }
  },
  created() {
    this.prepareData();
  },
  computed: {
    ...mapState({
      user: state => state.Auth.users,
      list: state => state.Hospital.listDoctor
    }),
    rows() {
      return this.employees.length
    }
  },
  methods: {
    async prepareData() {
      this.hospcode = this.user.hospcode
      this.Toast = this.$swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 1500,
        timerProgressBar: true,
      });
      this.swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: 'btn btn-success',
          cancelButton: 'btn btn-danger'
        },
        buttonsStyling: false
      })
      await this.getListDoctor(this.hospcode);
    },
    backToSetting() {
      const path = `/setting`
      if (this.$route.path !== path) this.$router.push(path)
    },
    generateTableListDoctor() {
      this.items_list_doctor = [];
      if (this.list) {
        this.list.forEach(item => {
          let data = {
            id: item.id,
            name: item.name,
          }
          this.items_list_doctor.push(data)
        })
      } else {
        this.items_list_doctor = [];
      }
    },

    //CRUD
    getListDoctor() {
      this.$store.dispatch('Hospital/onGetListDoctor', this.hospcode).then(async (res) => {
        if (res) {
          console.log("list", this.list)
          this.generateTableListDoctor();
        }
      })
    },
    async saveToList() {
      let data = {
        hospcode: this.hospcode,
        name: this.name
      }
      await this.$store.dispatch('Hospital/onCreateListDoctor', data).then(async (res) => {
        if (res.message === 200) {

          await this.getListDoctor();
        }
      })
    },
    async editDoctor(item) {
      await this.swalWithBootstrapButtons.fire({
        title: 'ยืนยันการแก้ไข?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'ตกลง',
        cancelButtonText: 'ยกเลิก',
        reverseButtons: true
      }).then(async (result) => {
        if (result.isConfirmed) {
          let data = {
            id: item.id,
            name: item.name,
            hospcode: this.hospcode
          }
          item.isEditing = false;
          await this.$store.dispatch('Hospital/onUpdateListDoctor', data).then(async (res) => {
            if (res.message === 200) {
              this.Toast.fire({
                icon: 'success',
                title: 'แก้ไขสำเร็จ'
              })
              await this.getListDoctor();
            }
          })

        } else if (result.dismiss === Swal.DismissReason.cancel) {
          this.$set(item, 'isEditing', true);
          Swal.close();
        }
      })
    },
    async deleteDoctor(id_list) {
      await this.swalWithBootstrapButtons.fire({
        title: 'ยืนยันการลบ?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'ตกลง',
        cancelButtonText: 'ยกเลิก',
        reverseButtons: true
      }).then((result) => {
        if (result.isConfirmed) {
          let data = {
            hospcode: this.hospcode,
            id: id_list
          }
          this.$store.dispatch('Hospital/onDeleteListDoctor', data).then(async (res) => {
            if (res) {
              await this.getListDoctor()
              this.Toast.fire({
                icon: 'success',
                title: 'ลบเรียบร้อย'
              })
            }
          });
        } else if (
            result.dismiss === Swal.DismissReason.cancel
        ) {
          Swal.close();
        }
      })
    },
    //for create
    checkFormValidity() {
      const valid = this.$refs.form.checkValidity()
      this.nameState = valid
      return valid
    },
    resetModal() {
      this.name = ''
      this.nameState = null
    },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault()
      // Trigger submit handler
      this.handleSubmit()
    },
    async handleSubmit() {
      if (!this.checkFormValidity()) {
        return
      }
      await this.saveToList();
      this.$nextTick(() => {
        this.$bvModal.hide('modal-prevent-closing')
      })
    },
    // for edit
    onEdit(item) {
      if (item.isEditing) {
        item.isEditing = false;
      } else {
        this.$set(item, 'isEditing', true)

      }
    }
  }

}
</script>

<style scoped>
.setting_list_police {
  height: 100%;
  min-height: 100vh;
}

p {
  color: #2DA1A9;
}

.header-text {
  font-size: 24px;
}

.action_link {
  color: #2DA1A9;
  font-size: 18px;
}

.action_link:hover {
  color: #247980;
}

.btn-delete:hover {
  color: white;
  background-color: red;
}

.btn-delete {
  color: red;
  background-color: white;
}

.btn-edit:hover {
  background-color: #f0ad4e;
}

.btn-edit {
  color: black;
  background-color: white;
}

.btn-save {
  color: #5cb85c;
  background-color: white;
}

.btn-save:hover {
  color: white;
  background-color: #5cb85c;
}
</style>
